console.log("Responsive.js loaded");
document.addEventListener("turbolinks:load", () => {
    const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
            const width = entry.contentRect.width;
            const height = entry.contentRect.height;
            const avg = (width + height) / 2;
            const textElements = entry.target.getElementsByClassName('responsive-text');

            for (const textElement of textElements) {
                if (textElement.dataset.rheight) {
                    const basis = textElement.dataset.rbasis;
                    let basisVal = width;
                    if (basis === 'avg') {
                        basisVal = avg;
                    } else if (basis === 'height') {
                        basisVal = height;
                    }
                    let size = (basisVal * textElement.dataset.rheight) / 100;
                    const max = textElement.dataset.rmax;
                    if (max && size > max) {
                        size = max;
                    }
                    textElement.style.fontSize = `${size}px`;
                }
            }
        }
    });

    document.querySelectorAll('.responsive-text-container').forEach(container => {
        resizeObserver.observe(container);
    });
});